import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Form, Button, Container, Row } from "react-bootstrap";
import { ToastContainer } from 'react-toastify';
import AuthContext from '../../context/AuthContext';


export default function Login() {
    const navigate = useNavigate()
    let { userDetails, onPressSignIn } = useContext(AuthContext)
    const [signInErrors, setSignInErrors] = useState({
        email_id: "",
        password: "",
    });
    const [signInState, setSignInState] = useState({
        email_id: "",
        password: "",
    });

    const onChange = (oEvent) => {
        setSignInState({
            ...signInState,
            [oEvent.target.name]: oEvent.target.value,
        });
        if (!!signInErrors[oEvent.target.name])
            setSignInErrors({
                ...signInErrors,
                [oEvent.target.name]: null,
            });
    };

    useEffect(() => {
        if (userDetails) {
            navigate("/", { replace: true });
        }
    }, [userDetails, navigate]);

    return (
        <>
            <Container className="ml-3 mr-3 mb-3">
                <Row>
                    <div className='col-md-12'>
                        <div className='content-section col-md-8'>
                            <legend className="border-bottom mb-4">Sign In</legend>
                            <Form autoComplete="off" noValidate>
                                <Form.Group className="mb-3" controlId="formEmailAddress">
                                    <Form.Label>Email Address</Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email_id"
                                        value={signInState.email_id}
                                        onChange={onChange}
                                        isInvalid={signInErrors.email_id}
                                    />
                                    <Form.Text className="text-muted">We'll never share your email address with anyone else.</Form.Text>
                                    <Form.Control.Feedback type="invalid">{signInErrors.email_id}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formPassword">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        name="password"
                                        value={signInState.password}
                                        onChange={onChange}
                                        isInvalid={signInErrors.password}
                                    />
                                    <Form.Control.Feedback type="invalid">{signInErrors.password}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formLogin">
                                    <Button type="submit" variant="primary" className="form-control" onClick={(oEvent) => onPressSignIn(oEvent, signInState, setSignInState, setSignInErrors)}>
                                        Login
                                    </Button>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                </Row>
                <ToastContainer />
            </Container>
        </>
    );
}